import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { meActions, selectMeFetched, selectMeLoading } from "views/auth/sagas/meSlice";

export const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const fetched = useSelector(selectMeFetched);
  const loading = useSelector(selectMeLoading);
  
  const isLoggedIn = sessionStorage.getItem("token");

  // useEffect(() => {
  //   if (isLoggedIn && !fetched && !loading) {
  //     dispatch(meActions.getMeRequest());
  //   }
  // }, [isLoggedIn, fetched, loading, dispatch]);

  if (!isLoggedIn) return <Navigate to="/" />;
  return children;
};
